import React, { useState } from "react";
import { Box, Paper, Typography } from "@material-ui/core";
import { css } from "@emotion/css";
import { useWatch, useFormContext } from "react-hook-form";
import LessonPreviewMobile from "./LessonPreviewMobile";
import LessonScreen from "./LessonScreen";
import QuizScreen from "./QuizScreen";
import ScreenSelector, { SelectedScreen } from "./ScreenSelector";
import { LessonFormData, PartFormData } from "../../types";
import { useActiveLocale } from "../../ActiveLocaleContext";

const PreviewColumn: React.VFC = () => {
  const { control } = useFormContext<LessonFormData>();
  const parts = (useWatch({ control, name: "parts" }) as PartFormData[] | undefined) ?? [];
  const { activeLocale } = useActiveLocale();

  const [selected, setSelected] = useState<SelectedScreen>({ kind: "lesson", partIndex: 0 });
  const part = parts[selected.partIndex];

  return (
    <Paper variant="outlined" className={styles.wrap}>
      <Typography variant="h6" gutterBottom>
        Preview
      </Typography>

      <ScreenSelector parts={parts} selected={selected} onChange={setSelected} />

      <Box className={styles.mobile}>
        <LessonPreviewMobile>
          {selected.kind === "lesson" ? (
            <LessonScreen part={part} locale={activeLocale} />
          ) : (
            <QuizScreen question={part?.questions?.[selected.questionIndex]} locale={activeLocale} />
          )}
        </LessonPreviewMobile>
      </Box>
    </Paper>
  );
};

export default PreviewColumn;

const styles = {
  wrap: css`
    position: sticky;
    top: 16px;
    padding: 12px;
    max-height: calc(100vh - 96px);
    overflow-y: auto;
  `,
  mobile: css`
    margin-top: 12px;
    display: flex;
    justify-content: center;
  `,
};
